import { AxiosResponse } from 'axios';

import { ApiService } from '../api/api.service';

export interface SputService {
  getPickupTimesForRestaurant(restaurantId: number, entreeCount: number): Promise<string[]>;
}

export class AppSputService extends ApiService implements SputService {
  getPickupTimesForRestaurant(restaurantId: number, entreeCount: number) {
    return this.httpClient
      .get(`/sput/v1/pickuptimes/${restaurantId}?itemCount=${entreeCount}`)
      .then((res: AxiosResponse<string[]>) => res.data)
      .catch(e => this.logAndThrowApiError('getPickupTimesForRestaurant', e));
  }
}
